export default function setupToolbarInjection(router) {
  const injectToolbarButtons = () => {
    const route = router.currentRoute.value;

    if (
      route.name === "Login" ||
      route.fullPath === "/login" ||
      route.fullPath === "/oauth2"
    )
      return;

    const toolbar = document.querySelector(".v-toolbar__content");
    if (!toolbar) return;

    toolbar.style.position = "relative";
    toolbar.style.display = "flex";
    toolbar.style.alignItems = "center";

    // -------- HOME ICON (left of logout) --------
    if (!document.querySelector("#toolbar-home-icon")) {
      const homeIcon = document.createElement("i");
      homeIcon.id = "toolbar-home-icon";
      homeIcon.className = "mdi mdi-home";
      homeIcon.title = "Home";

      homeIcon.style.cssText = `
        font-size: 28px;
        margin-right: 12px;
        cursor: pointer;
       background: linear-gradient(135deg, #337b52, #337b52);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        transition: transform 0.2s ease;
      `;

      homeIcon.onmouseover = () => {
        homeIcon.style.transform = "scale(1.2)";
      };
      homeIcon.onmouseleave = () => {
        homeIcon.style.transform = "scale(1)";
      };
      homeIcon.onclick = () => {
        router
          .push({ name: "HomeView" })
          .catch((err) => console.error("Routing error:", err));
      };

      toolbar.appendChild(homeIcon);
    }

    // -------- LOGOUT ICON (far right) --------
    if (!document.querySelector("#toolbar-logout-icon")) {
      const logoutIcon = document.createElement("i");
      logoutIcon.id = "toolbar-logout-icon";
      logoutIcon.className = "mdi mdi-logout";
      logoutIcon.title = "Logout";

      logoutIcon.style.cssText = `
        font-size: 28px;
        margin-left: auto;
        cursor: pointer;
        background: linear-gradient(135deg, #8B0000, #B22222);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        transition: transform 0.2s ease;
      `;

      logoutIcon.onmouseover = () => {
        logoutIcon.style.transform = "scale(1.2)";
      };
      logoutIcon.onmouseleave = () => {
        logoutIcon.style.transform = "scale(1)";
      };

      logoutIcon.onclick = async () => {
        const overlay = document.createElement("div");
        overlay.id = "logout-loading-overlay";
        overlay.innerHTML = `
          <div class="v-overlay__scrim" style="opacity: 0.6; background-color: black;"></div>
          <div class="v-overlay__content" style="
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 9999;
          ">
            <div class="v-progress-circular v-progress-circular--indeterminate" style="width: 60px; height: 60px;">
              <svg viewBox="22 22 44 44">
                <circle cx="44" cy="44" r="20.2" fill="none" stroke="white" stroke-width="3.6"/>
              </svg>
            </div>
          </div>
        `;
        overlay.className = "v-overlay v-overlay--active";
        overlay.style.cssText = `
          position: fixed;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.3);
          z-index: 9998;
          display: flex;
          align-items: center;
          justify-content: center;
        `;
        document.body.appendChild(overlay);

        try {
          const { doLogout } = await import("@/controllers/BackboneAPI.js");
          await doLogout();
        } catch (err) {
          console.error("Logout failed:", err);
        } finally {
          document.body.removeChild(overlay);
          window.location.replace("/login");
        }
      };

      toolbar.appendChild(logoutIcon);
    }
  };

  router.isReady().then(() => {
    setTimeout(injectToolbarButtons, 100);
  });

  router.afterEach(() => {
    setTimeout(injectToolbarButtons, 100);
  });
}
